import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';
import { ReCaptchaModule } from 'angular2-recaptcha';

import { InscricaoRouter } from './inscricao.router';
import { InscricaoService } from './shared/inscricao.service';

import { InscricaoComponent } from './inscricao.component';
import { AgendamentoComponent } from './agendamento/agendamento.component';
import { NotaEnemComponent } from './nota-enem/nota-enem.component';
import { CursoComponent } from './curso/curso.component';
import { CampusTurnoComponent } from './curso/campus-turno/campus-turno.component';
import { DadosPessoaisComponent } from './dados-pessoais/dados-pessoais.component';
import { SobreProvaComponent } from './sobre-prova/sobre-prova.component';
import { SobreCursoComponent } from './sobre-curso/sobre-curso.component';
import { PagamentoInscricaoComponent } from './pagamento/pagamento.component';
import { FinalizacaoComponent } from './finalizacao/finalizacao.component';
import { SelecaoCursoComponent } from './curso/selecao-curso/selecao-curso.component';
import { ImageCropperModule } from 'ng2-img-cropper';
import { PdfInscricaoService } from './shared/pdf-inscricao.service';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    InscricaoRouter,
    ImageCropperModule,
    ReCaptchaModule,
  ],
  providers: [
    InscricaoService,
    PdfInscricaoService,
  ],
  declarations: [
    InscricaoComponent,
    CursoComponent,
    CampusTurnoComponent,
    DadosPessoaisComponent,
    AgendamentoComponent,
    NotaEnemComponent,
    SobreProvaComponent,
    SobreCursoComponent,
    PagamentoInscricaoComponent,
    FinalizacaoComponent,
    FinalizacaoComponent,
    SelecaoCursoComponent,
  ],
  exports: [
    InscricaoComponent,
    CursoComponent,
    DadosPessoaisComponent,
    AgendamentoComponent,
    NotaEnemComponent,
    SobreProvaComponent,
    SobreCursoComponent,
    PagamentoInscricaoComponent,
    FinalizacaoComponent,
    FinalizacaoComponent,
    SelecaoCursoComponent,
  ],
})
export class InscricaoModule { }
